import bonuses from "@shared/sagas/bonuses";
import history from "@shared/sagas/history";
import jackpots from "@shared/sagas/jackpots";
import lobby from "@shared/sagas/lobby";
import user from "@shared/sagas/user";
import voucher from "@shared/sagas/voucher";
import { all, fork } from "redux-saga/effects";

import games from "./games";

export default function* root() {
  yield all([
    fork(user),
    fork(games),
    fork(lobby),
    fork(voucher),
    fork(bonuses),
    fork(jackpots),
    fork(history),
  ]);
}
